"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var ver = React.version.split('.').map(parseFloat);
function version() {
    return ver;
}
exports.version = version;
function batchedUpdates(cb) {
    ReactDOM.unstable_batchedUpdates(cb);
}
exports.batchedUpdates = batchedUpdates;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/compat.js
// module id = 200
// module chunks = 0 1 2 3 4 5 6